import actionTypes from './actionTypes';

const requestGlossary = (args) => ({
    type: actionTypes.REQUEST_GLOSSARY,
    payload: args,
});

const glossaryResponse = (success, errors, response) => ({
    type: actionTypes.GLOSSARY_RESPONSE,
    payload: {
        success,
        errors,
        response,
    },
});

export default {
    requestGlossary,
    glossaryResponse,
};
